import { Toast } from 'primereact/toast';
import { createContext, useContext, useRef } from 'react';

// crea el contexto
export const ContextAdminHorario = createContext();

//crea el hook para usarlo
export const useContextAdminHora = () => {
    return useContext(ContextAdminHorario);
};

//usa el provider
export const ContextAdminHoraProvider = ({ children }) => {
    const toast = useRef(null);

    //funcion para compartir enel Contexto
    const showToast = (severity, sumary, detail) => {
        toast.current.show({ severity, sumary, detail, life: 3000 });
    };

    return (
        <>
            <Toast ref={toast} />
            <ContextAdminHorario.Provider value={showToast}>
              {children}
            </ContextAdminHorario.Provider>
        </>
    );
};
